/**
 * `users.invites` (M92): when a new user gets the welcome / temp-password email. One so far:
 *
 *   send_on_create   creating a user (API POST /api/admin/users) also emails the invite, as
 *                    before M92. Off: the user is created without an email and an admin sends
 *                    it from Manage Users (POST /api/admin/users/:id/send-invite), which also
 *                    resends. Read by the create route (services/settings getSetting).
 *
 * Who: editPermission feature:manage_users (the key that opens Manage Users; admins always
 * pass). No readPermission: nothing outside the create route needs the value.
 * Edited on Settings → App settings. Default off (M92, client request: send from a button).
 */
import { z } from 'zod';
import { defineGroup } from '../define.js';
export const usersInvites = defineGroup('users.invites', {
    label: 'User invitations',
    editPermission: 'feature:manage_users',
    settings: {
        send_on_create: {
            type: z.boolean(),
            default: false,
            label: 'Email the invitation as soon as a user is created',
            help: 'On: creating a user emails their welcome and temporary password right away. Off: the user is created without an email, and an admin sends the invitation with the Send invite button on Manage Users.',
        },
    },
});
//# sourceMappingURL=users.js.map